// export const getMultipleOfThree = (markdown: string): string => {
//   // Match all <li> tags
//   const liTags = markdown.match(/<li[\s\S]*?<\/li>/g) || []
//   const liCount = liTags.length

//   // Calculate how many empty <li> tags are needed
//   const remainder = liCount % 3
//   const neededLi = remainder === 0 ? 0 : 3 - remainder

//   // Append the required empty <li> tags if needed
//   if (neededLi > 0) {
//     const emptyLiTags = '<li class=\'empty\'></li>'.repeat(neededLi)
//     return markdown.replace('</ul>', `${emptyLiTags}</ul>`)
//   }

//   return markdown
// }

export const getMultipleOfThree = (markdown: string): string => {
	if(!markdown) return ''
  const liTags: string[] = markdown.match(/<li[\s\S]*?<\/li>/g) || []
  const liCount = liTags.length
  const remainder = liCount % 3

  if (remainder === 1) {
    // Isolate the last real <li>
    const lastItem = liTags.pop()
    const middleItem = lastItem.replace(
      /<li(.*?)>/,
      '<li$1 class=\'middle_last\'>'
    )

    // Insert empty - middle - empty
    liTags.push(
      '<li class=\'empty\'></li>',
      middleItem,
      '<li class=\'empty\'></li>'
    )
  } else if (remainder === 2) {
    liTags.push('<li class=\'empty\'></li>')
  }

  const newUl = `<ul>${liTags.join('')}</ul>`
  return markdown.replace(/<ul>[\s\S]*?<\/ul>/, newUl)
}